import React from "react";

export default function Pagination({
  page,
  pageSize,
  total = 0,
  onPageChange,
}) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / (pageSize || 1)));

  return (
    <div className="mt-8 flex items-center justify-center gap-4">
      <button
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page <= 1}
        className="px-4 py-2 rounded bg-white border disabled:opacity-50"
      >
        Prev
      </button>

      <div className="text-sm text-[#5C665F]">
        Page {page} of {totalPages}
      </div>

      <button
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
        className="px-4 py-2 rounded bg-white border disabled:opacity-50"
      >
        Next
      </button>
    </div>
  );
}
